var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43747 0.20816C3.72085 0.20816 0.70813 3.22088 0.70813 6.9375C0.70813 10.6541 3.72085 13.6668 7.43747 13.6668C9.04025 13.6668 10.5123 13.1064 11.6683 12.1708L14.2704 14.7729C14.4033 14.9058 14.5835 14.9804 14.7714 14.9804C14.9593 14.9804 15.1395 14.9058 15.2723 14.7729C15.4052 14.64 15.4799 14.4598 15.4799 14.2719C15.4799 14.084 15.4052 13.9038 15.2723 13.771L12.6703 11.1689C13.6408 9.97244 14.1693 8.47808 14.1668 6.9375C14.1668 3.22088 11.1541 0.20816 7.43747 0.20816ZM2.12497 6.9375C2.12497 4.00341 4.50338 1.625 7.43747 1.625C10.3716 1.625 12.75 4.00341 12.75 6.9375C12.75 9.8716 10.3716 12.25 7.43747 12.25C4.50338 12.25 2.12497 9.8716 2.12497 6.9375Z",
    fill: "#F3F3F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.319ef7baf6c6872bb525b69058484473.svg";
export { ForwardRef as ReactComponent };